import { marked } from "marked";

import { sanitizeRichText } from "./sanitizeRichText";

export const sanitizeMarkdown = (markdown: string | null | undefined): string => {
  if (!markdown) {
    return "";
  }

  const html = marked.parse(markdown) as string;

  return sanitizeRichText(html);
};
